import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { Request, Confirm } from "./components";
import MUIButton from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";

enum Layout {
  Request,
  Cofirm,
}

export const MyAccountEmailScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"MyAccountEmail">["navigation"]>();
  const [layout, setLayout] = useState<Layout>(Layout.Request);
  const [email, setEmail] = useState<string>("");
  const [confirmed, setConfirmed] = useState<boolean>(false);

  return (
    <React.Fragment>
      {layout === Layout.Request ? (
        <Request
          onDone={(value) => {
            setEmail(value);
            setLayout(Layout.Cofirm);
          }}
        />
      ) : null}
      {layout === Layout.Cofirm ? (
        <Confirm email={email} onDone={() => setConfirmed(true)} />
      ) : null}
      <Dialog
        open={confirmed}
        onClose={() => navigation.goBack()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {LocalText.screens.myAccountEmail.emailChangeAlertTitle}
        </DialogTitle>
        <DialogActions>
          <MUIButton onClick={() => navigation.goBack()} autoFocus>
            {LocalText.common.ok}
          </MUIButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
